import AccountService from 'src/lib/api/account.service';

export async function searchAccounts({ commit }, { params }) {
  const response = await AccountService.searchAccounts({ params });
  if (response.status === 200) {
    commit('updateAccounts', { accounts: response.data });
  }
}

export async function getAccount(context, { id }) {
  const response = await AccountService.getAccount({ id });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function createAccount(context, { account, authentication }) {
  await AccountService.createAccount({ account, authentication });
}

export async function updateAccount(context, { id, account }) {
  await AccountService.updateAccount({ id, account });
}

export async function deleteAccount(context, { id }) {
  await AccountService.deleteAccount({ id });
}

export async function recoverAccount(context, { email }) {
  await AccountService.recoverAccount({ email });
}

export async function updatePassword(context, { id, token, authentication }) {
  await AccountService.updatePassword({ id, token, authentication });
}

export async function adminUpdatePassword(context, { id, token, password }) {
  await AccountService.adminUpdatePassword({ id, token, password });
}

export async function getAccountLogins(context, { id }) {
  const response = await AccountService.getAccountLogins({ id });
  return response.data;
}
